import React, { useState } from 'react'
import database from './firebase'
import './feedback.css'
import TextField from '@material-ui/core/TextField'
import { Button } from '@material-ui/core'
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight'
import AOS from 'aos';
import 'aos/dist/aos.css';
import motionImg3 from './img/feedback_img.png'
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

AOS.init();

// You can also pass an optional settings object
// below listed default settings
AOS.init({
  // Global settings:
  disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
  startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
  initClassName: 'aos-init', // class applied after initialization
  animatedClassName: 'aos-animate', // class applied on animation
  useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
  disableMutationObserver: false, // disables automatic mutations' detections (advanced)
  debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
  throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)
  

  // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
  offset: 120, // offset (in px) from the original trigger point
  delay: 200, // values from 0 to 3000, with step 50ms
  duration: 750, // values from 0 to 3000, with step 50ms
  easing: 'ease', // default easing for AOS animations
  once: false, // whether animation should happen only once - while scrolling down
  mirror: false, // whether elements should animate out while scrolling past them
  anchorPlacement: 'top-bottom', // defines which position of the element regarding to window should trigger the animation

});


function Feedback() {

    const [nameInput,setNameInput] = useState('');
    const [addressInput,setAddressInput] = useState('');
    const [messageInput,setMessageInput]  = useState('');

    const feedback = (e) => {
        e.preventDefault();
        if (nameInput !== "" && addressInput !== "" && messageInput !== ""){
            window.alert('Thank you for the feedback !');
            database.collection('feedback').add({
                name:nameInput,
                address:addressInput,
                message:messageInput
            });
        }
        else{
            window.alert('Invalid Inputs...')
        }
        setNameInput('');
        setAddressInput('');
        setMessageInput('');
    }

    return (
            <div className = 'feedback'>
                <LazyLoadImage effect="blur" className = 'feedback-img' src = {motionImg3} alt = 'logo' data-aos = 'fade-right'/>
                <form className = 'feedback_form' data-aos = 'zoom-in-up'>
                    <h1 className = 'feedback_form_h1'>Feedback.</h1>
                    <div className = 'feedback_form_about'>
                        <TextField id="standard-basic" label="Your Name" value = {nameInput} onChange = {event => setNameInput(event.target.value)} required/>
                        <TextField id="standard-basic" label="Your Address" value = {addressInput} onChange = {event => setAddressInput(event.target.value)} required/>
                    </div>
                    <div className = 'feedback_form_message'>
                        <TextField id="standard-multiline-static" label="Message" multiline rows={4}  value = {messageInput} onChange = {event => setMessageInput(event.target.value)} required/>
                        <Button variant = 'contained' color = 'secondary' type = 'submit' onClick = {feedback}>  Submit <KeyboardArrowRightIcon/></Button>
                    </div>
                </form>
            </div>
    )
}

export default Feedback
